import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { Box, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '36ch',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  large: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    margin: "auto"
  },
}));

// class ProductCompo extends Component {
//     state = {  }
//     render() {
//         return (
            
//         );
//     }
// }

// export default ProductCompo;
export default function ProductCompo(props) {
    const classes = useStyles();
    const { list } = props;
    return (
        <Grid container spacing={1}>
            {list ? list.map( prod =>
                <>
                <Grid item sm={12} md={6} lg={3}>
                    <Box style={{ "textAlign": "center"}} onClick={() => props.subDetails(prod)}>
                        <Avatar className={classes.large} alt={prod.name} src={prod.photos && prod.photos.length > 0 && prod.photos[0].filename ? `/stocks/photos/${prod.photos[0].filename}` : 'img/noImg.png'} />
                        <Typography variant="h6">{prod.name}</Typography>
                        <Typography variant="body1">x {prod.quantity}</Typography>
                    </Box>
                    
                </Grid>
                </>
            ):
                <Grid item xs={12}>
                    <Alert severity="warning">Aucun élément enregistré</Alert>
                </Grid>
            
            }
            
        </Grid>
        // V1 
        // <List className={classes.root}>
        //     {list.map( prod =>
        //         <>
        //         <ListItem alignItems="flex-start">
        //             <ListItemAvatar>
        //                 <Avatar alt={prod.name} src={prod.photos && prod.photos.length > 0 && prod.photos[0].filename ? `/stocks/photos/${prod.photos[0].filename}` : 'img/noImg.png'} />
        //             </ListItemAvatar>
        //             <ListItemText
        //                 primary={prod.name}
        //                 secondary={
        //                     <>
        //                         <Typography
        //                             component="span"
        //                             variant="body2"
        //                             className={classes.inline}
        //                             color="textPrimary"
        //                         >
        //                         x {prod.quantity}
        //                         </Typography>
        //                     </>
        //                 }
        //             />
        //         </ListItem>
        //         <Divider variant="inset" component="li" />
        //         </>
        //     )}
            
        // </List>
    )
}
